import { createRoute } from '@tanstack/react-router';
import { isValid, parse } from 'date-fns';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import {
  labPartnershipFilters,
  pharmacyTradeEnhancedStatusList,
  requirementKinds,
  tradesSources,
} from 'types/api/pharmacies/trades/trade';
import { tradeSellTypes, tradesInstanceStatus } from 'types/models';
import { compensatedBy, compensationMethod } from 'types/models/compensation';
import { z } from 'zod';

const pharmacyTradesRouteSearchSchema = z.object({
  query: z.string().optional(),
  date: z
    .string()
    .refine((val) => isValid(parse(val, 'yyyy-MM', new Date())), {
      message: 'Invalid date format',
    })
    .optional(),
  tagIds: z.array(z.coerce.number()).optional(),
  status: z.array(z.enum(tradesInstanceStatus)).optional(),
  enhancedStatuses: z.array(z.enum(pharmacyTradeEnhancedStatusList)).optional(),
  priority: z.enum(['all', 'priority']).optional(),
  source: z.enum(tradesSources).optional(),
  requirementKinds: z.array(z.enum(requirementKinds)).optional(),
  sellType: z.array(z.enum(tradeSellTypes)).optional(),
  compensationMethods: z.array(z.enum(compensationMethod)).optional(),
  compensatedBy: z.array(z.enum(compensatedBy)).optional(),
  labPartnership: z.enum(labPartnershipFilters).optional(),
});

export const pharmacyTradesRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/trades',
  validateSearch: pharmacyTradesRouteSearchSchema,
}).lazy(() => import('pages/pharmacy/Trades/TradesPage/TradesPage').then((d) => d.Route));
